<script setup>
import { Link, usePage } from "@inertiajs/vue3";
import { computed } from "vue";

const commerceSettings = computed(() => usePage().props.commerceSettings);
</script>

<template>
    <div class="bg-[#222] py-8 lg:py-2">
        <div class="outer-container flex h-full items-center">
            <div class="mx-auto flex w-full max-w-xl flex-col items-center justify-between gap-4 lg:flex-row">
                <Link
                    :text="$t('Privacy declaration')"
                    :href="commerceSettings.privacy_page_slug"
                />
                <Link
                    :text="$t('Terms and Conditions')"
                    :href="commerceSettings.terms_page_slug"
                />
                <Link
                    :text="$t('Disclaimer')"
                    :href="commerceSettings.disclaimer_slug ?? '#'"
                />
            </div>
        </div>
    </div>
</template>
